// apps/web/src/pages/TwoFAChallengePage.jsx
import TwoFactorChallengeWeb from '@mysimpledb/shared/components/Security/TwoFactorChallenge.web';

export default function TwoFAChallengePage({ setUserId }) {
  return <TwoFactorChallengeWeb setUserId={setUserId} />;
}
